<template>
  <div class="page-background-new">
    <div
      style="margin: 1rem;padding:0.75rem; line-height: 2rem;background-color: #fff;border-radius: 0.67rem;"
    >
      <div
        style="margin-bottom: 1.2rem; color: #fe5546; font-weight: 500; font-size: 1.13rem"
      >
        温馨提示:
      </div>
      <div
        style="color: #999; font-weight: 400; font-size: 0.87rem; line-height: 1.38rem"
      >
        <!--<div v-if="currentTab == 1">
              您还未持有按照相关规定的有效核酸报告，信息预登记后将引导您在本院完成核酸开单，请及时完成核酸检测!
            </div>
            <div v-if="currentTab == 0">
              核酸报告需要在7天内
            </div>-->
        <ul class="message-list">
          <li>核酸报告须为48小时内的有效报告</li>
          <li>
            如核酸检测在本院采集的可选择本院【陪护人证件号本院存在有效核酸报告】，如核酸报告为非本院采集的请选择【上传核酸报告】上传图片
          </li>
          <li>
            如核酸检测已采集但结果未出，请等核酸报告结果出具后再尝试添加
          </li>
          <li>
            添加成功后，请等待后台审核，如有疑问请与医院现场工作人员咨询
          </li>
        </ul>
      </div>
    </div>
    <div
      v-show="cardNo"
      style="height: 7rem; margin: 1rem 1rem 0 1rem; background: #09f; border-radius: 0.67rem"
    >
      <div class="user-info">
        <!-- <img :class="sexClass" :src="require('@assets/ic_user_portrait.png')" alt="" /> -->
        <div :class="sexClass"></div>
        <div style="line-height: 1.7rem">
          <div class="user-info-name">
            {{ userInfo.patientName }}
          </div>
          <div class="user-info-card-no" style="font-size: 0.866rem">
            住院号:
            {{ userInfo.patientCardNo }}
          </div>
        </div>
        <div class="card-type" @click="showCard = true">
          <van-icon name="arrow-down" color="white" />
          <!-- <img  style="width: 4.66rem;height: 2rem;background: #FFFFFF;border: 0px solid #FFFFFF;border-radius: 1rem;"
      :src="require('@assets/icon_change.png')" alt="" /> -->
        </div>
      </div>
    </div>
    <div class="escortpeople-add" :style="cardNo ? '' : 'margin-top: 2rem;'">
      <div
        v-show="!cardNo"
        class="escortpeople-add-form"
        style="position: relative; margin: -1rem 1rem 1rem"
      >
        <van-form>
          <van-field
            v-model="userInfo.patientCardNo"
            name="住院号"
            label="住院号:"
            placeholder="住院号"
            input-align="right"
                :rules="[{ required: true, message: '请填写住院号' }]"
            :style="'border-radius: 0.67rem 0.67rem 0 0;'"
          />
          <van-field
            v-model="userInfo.patientName"
            name="姓名"
            label="姓名:"
            placeholder="姓名"
            input-align="right"
                :rules="[{ required: true, message: '请填写姓名' }]"
            @mouseout="getPatientInfo"
          />
          <van-field
            v-model="userInfo.notShowIdCard"
            name="证件号"
            label="证件号:"
            placeholder="证件号"
            input-align="right"
                :rules="[
                  {
                    required: true,
                    pattern: /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/,
                    message: '请填写证件号'
                  }
                ]"
            :formatter="formIdCard"
          />
          <van-field
            v-model="userInfo.inpatientWard"
            name="病区"
            label="病区:"
            placeholder="病区"
                :rules="[{ required: true, message: '请填写病区' }]"
            input-align="right"
          />
          <van-field
            v-model="userInfo.wardPhone"
            name="病区电话"
            label="病区电话:"
            placeholder="病区电话"
            input-align="right"
                :rules="[
                  {
                    required: true,
                    pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
                    message: '请填写正确的手机号'
                  }
                ]"
          />
          <van-field
            v-model="userInfo.patientSexName"
            name="性别"
            label="性别:"
            placeholder="性别"
                :rules="[{ required: true, message: '请填写性别' }]"
            input-align="right"
            :style="'border-radius: 0 0 0.67rem 0.67rem;'"
          />
        </van-form>
      </div>
      <!-- <div style="color:red;padding: 0 1rem 0.8rem;font-size:0.9rem"></div> -->
      <!--<ph-fixed-tabs v-model="currentTab" :tabs="tabs"></ph-fixed-tabs>-->
      <div class="escortpeople-add-form">
        <van-form>
          <div
            style="padding-bottom: 1rem; background-color: white; border-radius: 0.67rem"
          >
            <div class="escortpeople-add-form-style">
              <van-field
                v-model="escortPeople.escortPeopleName"
                name="陪护人姓名"
                label="陪护人姓名:"
                placeholder="请输入姓名"
                input-align="right"
                :style="'border-radius: 0.67rem 0.67rem 0 0;'"
                :rules="[{ required: true, message: '请填写陪护人姓名' }]"
              />
              <van-field
                v-model="escortPeople.escortPeopleIdCard"
                name="陪护人证件号"
                label="陪护人证件号:"
                placeholder="请输入正确证件号"
                input-align="right"
                :rules="[
                  {
                    required: true,
                    pattern: /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/,
                    message: '请填写陪护人证件号'
                  }
                ]"
              />
              <van-field
                v-model="escortPeople.escortPhone"
                name="陪护人手机号"
                label="陪护人手机号:"
                placeholder="请输入手机号"
                input-align="right"
                :rules="[
                  {
                    required: true,
                    pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
                    message: '请填写正确的手机号'
                  }
                ]"
              />
              <van-field
                v-model="escortPeople.phone"
                name="住院人手机号"
                label="住院人手机号:"
                placeholder="住院人手机号"
                input-align="right"
                :rules="[{ required: true, message: '住院人手机号' }]"
              />
              <van-field
                v-model="escortPeople.detectionTime"
                readonly
                name="核酸检测日期"
                label="核酸检测日期:"
                placeholder="请选择"
                input-align="right"
                right-icon="arrow-down"
                @click="showStart = true"
              />
              <van-popup v-model="showStart" position="bottom">
                <van-datetime-picker
                  v-model="startDate"
                  type="date"
                  @cancel="showStart = false"
                  @confirm="confirmPicker"
                />
              </van-popup>
              <van-radio-group
                v-model="escortPeople.havReport"
                :style="
                  'margin: 0px 1rem;font-size: 1.07rem;border-bottom: 1px solid #ebedf0;'
                "
              >
                <div style="display: flex; align-items: center; height: 5rem">
                  <van-radio
                    name="1"
                    :style="'width: 50%;'"
                    @click="reportMessageShow = false"
                    >上传核酸报告:</van-radio
                  >
                  <div style="width: 50%; text-align: right">
                    <van-uploader
                      v-model="fileList"
                      :before-read="beforeRead"
                      :max-count="1"
                      :after-read="afterRead"
                    >
                      <img
                        style="width: 3rem"
                        :src="require('@assets/icon_addphoto.png')"
                      />
                    </van-uploader>
                  </div>
                </div>
                <van-radio name="0" @click="getRecord()"
                  >陪护人证件号本院存在有效核酸报告</van-radio
                >
                <div
                  style="margin: 1rem 0 1rem 1.39rem; color: #09f; font-weight: 500; font-size: 1rem"
                >
                  <div
                    v-for="(item, index) in records"
                    :key="index"
                    style="display: flex"
                  >
                    <div>本院报告查询结果：{{ item.detectionTime }}</div>
                    <div style="padding-left: 1rem">
                      {{ item.detectionResult }}
                    </div>
                  </div>
                </div>
                <div
                  v-show="reportMessageShow"
                  style="
                    margin: 1rem 0 1rem 1.39rem;
                    color: #fe5546;
                    font-weight: 400;
                    font-size: 0.73rem;
                    line-height: 1.33rem;
                  "
                >
                  上方录入的陪护证件号未查到有效报告，请选择上传核酸报告或本院报告结果未出，请等出报告后再尝试添加
                </div>
              </van-radio-group>
              <!--<van-field
            v-show="currentTab == 0"
            name="uploader"
            label="上传核酸报告:"
            :style="'height: 5rem;'"
          >
          </van-field>-->
              <van-field
                name="uploader"
                :style="'height: 5rem;'"
                label="陪护人身份证头像面:"
                placeholder=""
              >
                <template #input>
                  <van-uploader
                    v-model="photoList"
                    :before-read="beforeRead"
                    :max-count="1"
                    :after-read="afterPhotoRead"
                    :style="'margin-left: 10rem;'"
                  >
                    <img
                      style="width: 3rem"
                      :src="require('@assets/icon_addphoto.png')"
                    />
                  </van-uploader>
                </template>
              </van-field>
              <van-field
                name="uploader"
                :style="'height: 5rem;'"
                label="陪护人身份证国徽面:"
                placeholder=""
              >
                <template #input>
                  <van-uploader
                    v-model="idCardList"
                    :before-read="beforeRead"
                    :max-count="1"
                    :after-read="afterIdCardRead"
                    :style="'margin-left: 10rem;'"
                  >
                    <img
                      style="width: 3rem"
                      :src="require('@assets/icon_addphoto.png')"
                    />
                  </van-uploader>
                </template>
              </van-field>
              <van-field
                name="uploader"
                :style="'height: 5rem;'"
                label="健康码:"
                placeholder=""
              >
                <template #input>
                  <van-uploader
                    v-model="jkmList"
                    :before-read="beforeRead"
                    :max-count="1"
                    :after-read="afterJkmRead"
                    :style="'margin-left: 10rem;'"
                  >
                    <img
                      style="width: 3rem"
                      :src="require('@assets/icon_addphoto.png')"
                    />
                  </van-uploader>
                </template>
              </van-field>
              <!-- <van-field
                name="uploader"
                :style="'height: 5rem;'"
                label="行程码:"
                placeholder=""
              >
                <template #input>
                  <van-uploader
                    v-model="xcmList"
                    :before-read="beforeRead"
                    :max-count="1"
                    :after-read="afterXcmRead"
                    :style="'margin-left: 10rem;'"
                  >
                    <img
                      style="width: 3rem"
                      :src="require('@assets/icon_addphoto.png')"
                    />
                  </van-uploader>
                </template>
              </van-field> -->
            </div>
            <!--<van-field
            v-model="verifyCode"
            :disabled="countDownTime != 0"
            placeholder="请输入图形验证码"
            :style="'text-align: left;'"
            :rules="[{ required: true, message: '请填写图形验证码' }]"
          >
            <img
              slot="right-icon"
              :src="verifyCodeImage"
              alt=""
              style="border-radius: 0.2rem;"
              @click="getVerifyCode"
            />
          </van-field>
          <van-field
            v-model="phoneCode"
            maxlength="6"
            placeholder="短信验证码"
            :rules="[{ required: true, message: '请填写短信验证码' }]"
          >
            <span
              v-if="verifyCodeImage"
              slot="right-icon"
              class="user-setting-phone-send-verifycode"
              :style="countDownTime ? 'color: gray;' : 'color: #09f'"
              :disabled="countDownTime > 0"
              @click="sendCode"
            >
              {{ countDownTime ? `${countDownTime}s后重新发送` : "发送验证码" }}
            </span>
          </van-field>-->
          </div>
          <ph-button
            v-if="flag !== 'edit'"
            :style="
              'margin: 2rem auto;background: #0099FF;border-radius: 2rem;width: 22.33rem;height: 3.6rem;'
            "
            @click="subCommit"
          >
            确认登记
          </ph-button>
          <ph-button
            v-if="flag === 'edit'"
            :style="
              'margin: 2rem auto;background: #0099FF;border-radius: 2rem;width: 22.33rem;height: 3.6rem;'
            "
            @click="subCommit('edit')"
          >
            确认修改
          </ph-button>
        </van-form>
      </div>
      <van-popup v-model="showCard" round position="bottom">
        <van-picker
          show-toolbar
          :columns="cards"
          @cancel="showCard = false"
          @confirm="cardConfirm"
        />
      </van-popup>
    </div>
  </div>
</template>
<script>
//import PHFixedTabs from "@/components/PHFixedTabs.vue";
import PhButton from "@/components/PhButton.vue";
export default {
  name: "addescortpeople",
  components: { PhButton },
  data() {
    return {
      userInfo: {},
      escortPeople: {
        escortPeopleName: "",
        escortPeopleIdCard: "",
        phone: "",
        detectionTime: "",
        reportUrl: "",
        photoUrl: "",
        escortPhone: "",
        havReport: "1",
        jkmUrl: "",
        // xcmUrl: "",
        idCardPhoto: "",
        detectionResult: "",
        headImgUrl: ""
      },
      phoneCode: "",
      ftype: "2",
      qrtype: "1",
      tabs: ["有核酸报告", "无核酸报告"],
      currentTab: 0,
      verifyCodeImage: "",
      verifyCode: "",
      countDownTime: 0,
      startDate: "",
      showStart: false,
      timer: null,
      fileList: [],
      photoList: [],
      idCardList: [],
      jkmList: [],
      // xcmList: [],
      records: [],
      reportMessageShow: false,
      cardNo: "",
      cardList: [],
      showCard: false,
      flag: "", // edit 修改(核酸报告更新等)
      escortQueryInfo: {} // 修改时url携带参数
    };
  },
  computed: {
    sexClass() {
      var sex = 0;
      if (this.userInfo && this.userInfo.idCard) {
        const value = this.userInfo.idCard;
        if (value.length === 15) {
          sex = value.substr(14, 1) % 2 || 2;
        }
        if (value.length === 18) {
          sex = value.substr(16, 1) % 2 || 2;
        }
      }
      if (sex == 1) {
        return "user-info-portrait-man";
      } else if (sex == 2) {
        return "user-info-portrait-woman";
      }
      return "user-info-portrait";
    },
    cards() {
      return this.cardList.map(item => {
        return {
          text: item.patientName + " " + item.patientCardNo,
          ...item
        };
      });
    }
  },
  mounted() {
    //this.getVerifyCode();
    this.setBaseFontSize();
  },
  created() {
    //  this.$http
    //    .post(this.$api.USER_BASE_INFO, {
    //      functionType: this.ftype,
    //      eleFlag: this.qrtype === "2" ? "1" : "0",
    //    })
    //    .then((res) => {
    //      this.userInfo = res;
    //      this.escortPeople.phone = this.userInfo.phone;
    //    });
    this.startDate = this.$moment()
      .add(-this.startBefore, "day")
      .toDate();
    const querys = this.$route.query;
    this.cardNo = querys.cardNo;
    if (this.cardNo) {
      this.getCardList();
    }
    // 更新核酸等数据
    if (querys.flag === "edit") {
      this.$set(this.escortPeople, "escortPeopleName", querys.name);
      this.$set(this.escortPeople, "escortPeopleIdCard", querys.idCard);
      this.$set(this.escortPeople, "phone", querys.patientPhone);
      this.$set(this.escortPeople, "escortPhone", querys.escortPhone);
      this.$set(this.escortPeople, "detectionTime", querys.detectionTime);
      this.startDate = this.$moment(querys.detectionTime).toDate();
      this.flag = querys.flag;
      // 陪护人参数以及病人信息等其他参数
      this.escortQueryInfo = querys;
      // 审核中点击查看按钮时增加回填内容
      if (querys.isAuditing === "1") {
        querys.photoUrl = querys.headImgUrl;
        // 审核中查看
        this.getFilesUrl(querys);
      }
    }
  },
  beforeDestroy() {
    let htmlDom = document.getElementsByTagName("html")[0];
    htmlDom.style.fontSize = "";
  },
  methods: {
    formatFileUrl(listType, urlType, querys) {
      const BaseUrl = "https://app.fjlyrmyy.com";
      this[listType] = [
        {
          url: BaseUrl + querys[urlType],
          width: "3rem",
          beforeDelete: () => {
            this[listType] = [];
            this.escortPeople[urlType] = "";
          }
        }
      ];
      this.escortPeople[urlType] = querys[urlType];
    },
    // 图片回填
    getFilesUrl(querys) {
      this.formatFileUrl("fileList", "reportUrl", querys);
      this.formatFileUrl("photoList", "photoUrl", querys);
      this.formatFileUrl("idCardList", "idCardPhoto", querys);
      // this.formatFileUrl("xcmList", "xcmUrl", querys);
      this.formatFileUrl("jkmList", "jkmUrl", querys);
    },
    setBaseFontSize() {
      /*上面设置font-size的代码*/
      let htmlWidth =
        document.documentElement.clientWidth || document.body.clientWidth; // 获取宽度最好有个兼容的方案，避免某些情况下第一种获取不到可以选择第二种
      //获取html
      let htmlDom = document.getElementsByTagName("html")[0];
      htmlDom.style.fontSize = htmlWidth > 640 ? "16px" : htmlWidth / 25 + "px";
    },
    formIdCard(idCard) {
      // let card = "";
      // if (idCard) {
      //   card = idCard.substr(0, 6) + "*****" + idCard.substr(idCard.length - 4);
      // }
      return idCard;
    },
    getCardList() {
      this.$http
        .post(this.$api.ESCORTPEOPLE_CARD_LIST, {
          functionType: this.ftype
        })
        .then(res => {
          this.cardList = res;
          if (this.cardList.length) {
            if (this.cardNo) {
              this.cardList.map(item => {
                if (item.patientCardNo == this.cardNo) {
                  this.userInfo = {
                    cardNo: item.patientCardNo,
                    patientName: item.patientName,
                    ...item,
                    notShowIdCard: item.patientIdCard
                  };
                }
              });
            } else {
              this.userInfo = {
                ...res[0],
                notShowIdCard: res[0].patientIdCard
              };
            }
          }
        });
    },
    toCardList() {
      this.$router.push({
        path: "/user/components/changecardview?ftype=2"
      });
    },
    getVerifyCode() {
      this.$http.post(this.$api.USER_VERIFY_CODE, {}).then(res => {
        this.verifyCodeId = res.picId;
        this.verifyCodeImage = res.url;
      });
    },
    sendCode() {
      if (!this.verifyCode) {
        this.$toast("请输入图形验证码");
        return;
      }
      this.confirmSendCode();
    },
    confirmSendCode() {
      this.$http
        .post(this.$api.ESCORTPEOPLE_SENMSG, {
          picId: this.verifyCodeId,
          picCode: this.verifyCode,
          phone: this.escortPeople.phone
        })
        .then(() => {
          this.startCountDown();
        });
    },
    startCountDown() {
      clearInterval(this.timer);
      this.timer = null;
      this.countDownTime = 60;
      this.timer = setInterval(() => {
        if (this.countDownTime > 0) {
          this.countDownTime -= 1;
        } else {
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },
    beforeRead(file) {
      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        this.$toast("请上传图片");
        return false;
      }
      return true;
    },
    //  图片文件压缩
    async fileToComporess(file, callback) {
      // 此时可以自行将文件上传至服务器
      const fileName = file.file.name;
      const img = await this.fileToCompressUrl(file.file);
      img.onload = () => {
        const files = this.imgToCanvasAndCompress(img);
        const file = this.dataURLtoFile(files, fileName);
        callback(file);
      };
    },
    // 文件上传请求
    fileToUpload(files, listType, urlType, callback) {
      // 此时可以自行将文件上传至服务器
      let formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
      formData.append("file", files);
      console.log('formData',formData)
      this.$http
        .upLoad(this.$api.ESCORTPEOPLE_UPLOAD, formData, {
          header: { "Content-Type": "multipart/form-data; charset=UTF-8;" }
        })
        .then(res => {
          this[listType] = [];
          this[listType].push({
            url: res.path,
            width: "3rem",
            beforeDelete: () => {
              this[listType] = [];
              this.escortPeople[urlType] = "";
            }
          });
          this.escortPeople[urlType] = res.path;
          if (callback && typeof callback === "function") {
            callback();
          }
        });
    },
    async afterRead(file) {
      this.fileToComporess(file, files => {
        console.log('file',file)
        console.log('files',files)
        this.fileToUpload(files, "fileList", "reportUrl", this.showTipCall);
      });
    },
    afterPhotoRead(file) {
      this.fileToComporess(file, files => {
        this.fileToUpload(files, "photoList", "photoUrl");
      });
    },
    afterJkmRead(file) {
      this.fileToComporess(file, files => {
        this.fileToUpload(files, "jkmList", "jkmUrl");
      });
    },
    afterXcmRead(file) {
      this.fileToComporess(file, files => {
        // this.fileToUpload(files, "xcmList", "xcmUrl");
      });
    },
    afterIdCardRead(file) {
      this.fileToComporess(file, files => {
        this.fileToUpload(files, "idCardList", "idCardPhoto");
      });
    },
    subCommit(flag) {
      if (!this.userInfo.patientCardNo) {
        this.$toast("请输入病人住院号!");
        return;
      }
      if (!this.userInfo.patientCardNo) {
        this.$toast("请输入病人姓名!");
        return;
      }
      if (!this.userInfo.patientIdCard) {
        this.$toast("请输入病人身份证!");
        return;
      }
      if (this.escortPeople.havReport == 1) {
        if (!this.escortPeople.reportUrl) {
          this.$toast("请上传检测报告!");
          return;
        }
      } else {
        if (this.records.length == 0) {
          this.$toast(
            "录入的陪护证件号未查到有效报告，请选择上传核酸报告或本院报告结果未出，请等出报告后再尝试添加!"
          );
          return;
        }
      }
      if (!this.escortPeople.photoUrl) {
        this.$toast("请上传证件正面照片!");
        return;
      }
      if (!this.escortPeople.idCardPhoto) {
        this.$toast("请上传证件反面照!");
        return;
      }
      if (!this.escortPeople.detectionTime) {
        this.$toast("请选择核酸检测日期!");
        return;
      }
      if (!this.escortPeople.jkmUrl) {
        this.$toast("请上传健康码!");
        return;
      }
      // if (!this.escortPeople.xcmUrl) {
      //   this.$toast("请上传行程码!");
      //   return;
      // }
      if (flag === "edit") {
        this.subCommitEdit();
      } else {
        this.subComitAdd();
      }
    },
    subComitAdd() {
      this.$http
        .post(this.$api.ESCORTPEOPLE_ADD, {
          phoneCode: this.phoneCode,
          functionType: "2",
          ...this.userInfo,
          ...this.escortPeople,
          patientCardNo: this.userInfo.patientCardNo,
          name: this.escortPeople.escortPeopleName,
          idCard: this.escortPeople.escortPeopleIdCard
        })
        .then(() => {
          this.$toast("登记成功，待医院相关人员审核!");
          this.$router.push({ path: "/escortpeople/list?ftype=2&qrtype=1" });
        });
    },
    // 更新提交
    subCommitEdit() {
      this.$http
        .post(this.$api.ESCORTPEOPLE_UPDATE, {
          escortId: this.escortQueryInfo.id,
          phoneCode: this.phoneCode,
          functionType: "2",
          ...this.userInfo,
          ...this.escortPeople,
          name: this.escortPeople.escortPeopleName,
          idCard: this.escortPeople.escortPeopleIdCard
        })
        .then(() => {
          this.$toast("更新核酸成功，待医院相关人员审核!");
          this.$router.push({ path: "/escortpeople/list?ftype=2&qrtype=1" });
        });
    },
    confirmPicker() {
      this.showStart = false;
      this.escortPeople.detectionTime = this.$moment(this.startDate).format(
        "YYYY-MM-DD"
      );
    },
    getRecord() {
      this.reportMessageShow = false;
      if (!this.escortPeople.escortPeopleIdCard) {
        this.$toast("请输入陪护人身份证!");
        this.escortPeople.havReport = "1";
        return;
      }
      this.$http
        .post(this.$api.ESCORTPEOPLE_GETRECORD, {
          idCard: this.escortPeople.escortPeopleIdCard,
          name: this.escortPeople.escortPeopleName
        })
        .then(res => {
          this.records = res;
          if (this.records.length == 0) {
            this.reportMessageShow = true;
          } else {
            this.escortPeople.detectionTime = res[0].detectionTime;
            this.escortPeople.detectionResult = res[0].detectionResult;
          }
        });
    },
    cardConfirm(v) {
      this.userInfo = {
        ...v
      };
      this.showCard = false;
    },
    getPatientInfo() {
      if (!this.userInfo.patientCardNo) {
        this.$toast("请输入病人住院号!");
        return;
      }
      if (!this.userInfo.patientName) {
        this.$toast("请输入病人姓名!");
        return;
      }
      let name = this.userInfo.patientName;
      let cardNo1 = this.userInfo.patientCardNo;
      this.userInfo = {};
      this.userInfo = {
        patientName: name,
        patientCardNo: cardNo1
      };
      this.$http
        .post(this.$api.USER_BASE_INFO, {
          functionType: this.ftype,
          eleFlag: this.qrtype === "2" ? "1" : "0",
          cardNo: this.userInfo.patientCardNo,
          name: this.userInfo.patientName,
          cardType: "2"
        })
        .then(res => {
          this.userInfo = {
            name: res.patientName,
            patientName: res.patientName,
            patientCardNo: res.cardNo,
            patientIdCard: res.idCard,
            inpatientWard: res.officeName || res.office,
            patientSex: res.sexCode,
            patientSexName:
              res.sexCode == 1 ? "男" : res.sexCode == 2 ? "女" : "未知",
            notShowIdCard: res.idCard,
            ...res
          };
        });
    },
    // 提示拨打病区电话
    showTipCall() {
      const phone = this.userInfo.wardPhone || this.escortQueryInfo.wardPhone;
      if (!phone) return;
      this.$dialog.confirm({
        message: `添加陪护人后，请及时拨打病区电话：${phone}`
      });
    },
    dataURLtoFile(dataurl, filename) {
      // 获取到base64编码
      const arr = dataurl.split(",");
      // 将base64编码转为字符串
      const bstr = window.atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n); // 创建初始化为0的，包含length个元素的无符号整型数组
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {
        type: "image/jpeg"
      });
    },
    async fileToCompressUrl(file) {
      const img = await this.fileToImg(file);
      return img;
    },
    fileToImg(file) {
      var reader = new FileReader();
      var img = new Image();
      // 文件base64化，以便获知图片原始尺寸
      reader.onload = function(e) {
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
      return img;
    },
    imgToCanvasAndCompress(img) {
      var canvas = document.createElement("canvas");
      var context = canvas.getContext("2d");
      const maxW = 1000;
      const maxH = 800;
      const originW = img.width;
      const originH = img.height;
      var targetWidth = originW;
      var targetHeight = originH;
      // 图片尺寸超过400x400的限制
      if (originW > maxW || originH > maxH) {
        if (originW / originH > maxW / maxH) {
          // 更宽，按照宽度限定尺寸
          targetWidth = maxW;
          targetHeight = Math.round(maxW * (originH / originW));
        } else {
          targetHeight = maxH;
          targetWidth = Math.round(maxH * (originW / originH));
        }
      }
      canvas.width = targetWidth;
      canvas.height = targetHeight;
      // 核心JS就这个
      context.drawImage(img, 0, 0, targetWidth, targetHeight);
      return canvas.toDataURL("image/jpeg", 0.92);
    }
  }
};
</script>
<style lang="less" scoped>
.user-info {
  position: relative;
  display: flex;
  align-items: center;
  padding: 1rem 1.37rem;
  color: white;
  &-portrait {
    width: 3.37rem;
    height: 3.37rem;
    margin-right: 0.87rem;
    background-image: url("~@/assets/ic_user_portrait_common.png");
    background-repeat: no-repeat;
    background-size: 3.37rem;

    &-man {
      width: 3.73rem;
      height: 3.73rem;
      margin-right: 0.87rem;
      background-image: url("~@/assets/ic_user_portrait_man.png");
      background-repeat: no-repeat;
      background-size: 3.73rem;
    }
    &-woman {
      width: 3.73rem;
      height: 3.73rem;
      margin-right: 0.87rem;
      background-image: url("~@/assets/ic_user_portrait_woman.png");
      background-repeat: no-repeat;
      background-size: 3.73rem;
    }
  }
  .card-type {
    // margin-right: 1rem;
    // margin-right: 1rem;

    position: absolute;
    //top: 1.88rem;
    right: 1.25rem;
    margin-left: auto;
    //padding: 0 0.77rem;
    //color: #09f;
    //font-size: 1rem;
    //background-color: white;
    //border: solid 0.03rem #fff;
    //border-radius: 0.935rem;
  }
}
.escortpeople-add {
  position: relative;
  margin: -1rem 0 0 0;
  &-form {
    margin: 0 1rem;
  }
}
.message-list {
  color: #fe5546;
  font-weight: 400;
  font-size: 0.87rem;
  line-height: 1.47rem;
  //padding-left: 1rem;
  li {
    padding-left: 0.8rem;
    list-style-type: none;
    background: url("~@/assets/icon_diamond.png") no-repeat 0 0.4rem;
    background-size: 0.5rem 0.5rem;
  }
  //list-style-image: url('~@/assets/icon_diamond.png');
}
</style>
<style lang="less">
.escortpeople-add {
  &-form {
    .van-field__label {
      width: 8rem;
      margin-right: 0;
    }
    .van-radio__icon {
      height: auto;
    }
    .van-radio__label {
      color: #646566;
    }
    .van-uploader__preview {
      margin: 0;
    }
    .van-uploader__preview-image {
      width: 3rem;
      height: 3rem;
    }
    &-style {
      /**  .van-field__control{
      text-align: right;
    } */
      .van-field__error-message {
        text-align: right;
      }
      .van-icon {
        font-size: 0.8rem;
      }
    }
    .van-field--error {
      height: auto !important;
    }
    .van-cell {
      align-items: center;
      height: 3.66rem;
      font-size: 1.07rem;
    }
  }
}
</style>
